import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { Inbox, Calendar, Shield, Bell, ArrowRight, Sparkles } from 'lucide-react';

const FacturesRecuesPage = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <h1 className="text-2xl font-bold text-gray-800">Factures reçues</h1>
            <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full font-medium" data-testid="badge-2026-feature">
              Réforme 2026
            </span>
          </div>
          <p className="text-gray-500 text-sm">
            Factures fournisseurs reçues via votre Plateforme Agréée
          </p>
        </div>
      </div>

      {/* Info banner */}
      <Card className="border-blue-200 bg-gradient-to-r from-blue-50/50 to-indigo-50/30">
        <CardContent className="p-5">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
              <Shield className="h-6 w-6 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="font-bold mb-1">Réforme de la facturation électronique 2026-2027</h3>
              <p className="text-sm text-muted-foreground">
                Depuis le 1er septembre 2026, toutes les entreprises, y compris les micro-entrepreneurs (même en franchise de TVA),
                doivent pouvoir recevoir les factures électroniques de leurs fournisseurs via une
                Plateforme Agréée. Cet espace est dès maintenant prêt à les centraliser.
              </p>
              <Link to="/conformite-2026" className="text-sm text-blue-700 font-medium hover:underline inline-flex items-center gap-1 mt-2" data-testid="link-conformite">
                En savoir plus sur la réforme <ArrowRight className="h-3 w-3" />
              </Link>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Empty state — bientôt disponible */}
      <Card className="border-dashed border-2 border-slate-200">
        <CardContent className="p-12 text-center">
          <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-5">
            <Inbox className="h-10 w-10 text-slate-400" />
          </div>
          <h2 className="text-xl font-bold mb-2">Aucune facture reçue pour le moment</h2>
          <p className="text-sm text-muted-foreground max-w-md mx-auto mb-6">
            La connexion à votre Plateforme Agréée sera activée dans Capsule Patrimoine
            prochainement, en avance sur l'obligation d'émission du 1er septembre 2027.
          </p>

          <div className="grid sm:grid-cols-3 gap-3 max-w-2xl mx-auto mb-6">
            <div className="flex flex-col items-center gap-2 p-3 bg-emerald-50 rounded-lg border border-emerald-100" data-testid="step-info-1">
              <Sparkles className="h-5 w-5 text-emerald-600" />
              <p className="text-xs font-medium text-emerald-900">PA sélectionnée</p>
              <p className="text-xs text-emerald-700">Printemps 2026</p>
            </div>
            <div className="flex flex-col items-center gap-2 p-3 bg-amber-50 rounded-lg border border-amber-100" data-testid="step-info-2">
              <Calendar className="h-5 w-5 text-amber-600" />
              <p className="text-xs font-medium text-amber-900">Intégration API</p>
              <p className="text-xs text-amber-700">Été 2026</p>
            </div>
            <div className="flex flex-col items-center gap-2 p-3 bg-blue-50 rounded-lg border border-blue-100" data-testid="step-info-3">
              <Bell className="h-5 w-5 text-blue-600" />
              <p className="text-xs font-medium text-blue-900">Notification</p>
              <p className="text-xs text-blue-700">À chaque facture reçue</p>
            </div>
          </div>

          <Link to="/conformite-2026">
            <Button className="bg-emerald-600 hover:bg-emerald-700" data-testid="cta-en-savoir-plus">
              Découvrir la réforme 2026 <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};

export default FacturesRecuesPage;
